import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Come ricevo il materiale?',
  a: 'Immediatamente dopo il pagamento ricevi un link per scaricare tutti i PDF in alta risoluzione. Nessuna attesa.'
}, {
  q: 'I materiali sono stampabili e distribuibili agli allievi?',
  a: 'Sì. La licenza ti permette di stampare e distribuire le attività e le verifiche ai tuoi studenti o al tuo team.'
}, {
  q: 'Il contenuto è aggiornato agli standard 2025/2026?',
  a: 'Assolutamente. Il sistema include Matter 1.3, Thread, AI applicata al BAS e la Direttiva EPBD IV (NZEB 2030).'
}, {
  q: 'È adatto anche se parto da zero?',
  a: 'Sì. I Tomi 1 e 2 coprono le basi, ma il sistema scala progressivamente fino al livello Elite per professionisti Senior.'
}, {
  q: 'Come funziona la garanzia di 7 giorni?',
  a: "Se non sei soddisfatto entro 7 giorni dall'acquisto, scrivi a supporto e ti rimborsiamo integralmente. Senza domande."
}, {
  q: 'Quali metodi di pagamento accettate?',
  a: 'Carta di credito, PayPal e tutti i principali metodi di pagamento sicuri tramite Stripe.'
}, {
  q: 'Qual è la differenza tra il Sistema Base e il Sistema Elite?',
  a: "Il Sistema Base include i 6 Tomi completi, le slide LIM, gli schemi elettrici e i 4 Bonus (valore €250 a €27,90). Il Sistema Elite aggiunge l'Archivio Smart Home Pro Elite con Building Automation Industriale, Digital Twin, IA applicata al BAS e casi studio europei (valore €370 a €37,90). Pensato per System Integrator e ITS Academy."
}, {
  q: "Posso usare i materiali in un corso ITS o in un'azienda di formazione?",
  a: "Sì. La licenza copre l'uso didattico in scuole, ITS Academy, centri di formazione professionale e corsi aziendali. Puoi distribuire le attività ai tuoi allievi senza limiti di classe."
}, {
  q: 'Devo avere già esperienza con KNX, Home Assistant o ETS 6?',
  a: 'No. Il sistema è progettato per accompagnarti gradualmente: parti dai protocolli base nel Tomo 1, passi alla configurazione ETS 6 nel Tomo 4 e arrivi ai progetti complessi nel Tomo 6. Anche se non hai mai aperto ETS, troverai guide passo-passo.'
}, {
  q: 'Posso usare il Sistema su tablet, PC e in stampa?',
  a: 'Sì. Tutti i materiali sono in PDF ad alta risoluzione, ottimizzati sia per la visualizzazione su tablet e LIM in aula, sia per la stampa in formato A4. Le slide sono compatibili con tutti i sistemi LIM.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 sm:py-14 px-4 bg-brand-dark" data-id="element-93">
      <div className="max-w-3xl mx-auto" data-id="element-94">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-10 uppercase text-brand-cream" data-id="element-95">
          Domande Frequenti
        </motion.h2>

        <div className="space-y-3" data-id="element-96">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.03
        }} className="bg-brand-card border border-white/10 rounded-xl overflow-hidden" data-id="element-97">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-white/5 transition-colors gap-3" data-id="element-98">
                <span className="font-bold text-brand-cream text-sm sm:text-base" data-id="element-99">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-orange transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-100" />
              </button>

              <AnimatePresence data-id="element-101">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-102">
                    <div className="px-5 pb-5 pt-0 text-gray-400 font-medium text-sm sm:text-base leading-relaxed" data-id="element-103">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}